/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import axios, { AxiosInstance } from "axios";

import { VApplication } from "../application/index";
import { DeviceInfoService } from "./device-info.service";

const SERVICE_NAME = "dummy-rest.service";
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require("is_js");

interface IProps {
    baseURL: string;
    timeout?: number;
    headers?: any;
}

const getDeviceInfoService = () => {
    const app = VApplication.getInstance();
    return app?.getSync("services.DeviceInfoService") as DeviceInfoService;
};

export class ProductDetailRestService {
    name = SERVICE_NAME;
    private static instance: ProductDetailRestService;

    private api: AxiosInstance;

    private constructor(props: IProps | any) {
        const deviceInfoService = getDeviceInfoService();
        this.api = axios.create({
            baseURL: props.baseURL,
            timeout: props.timeout ?? 30000, // 30 secs
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...{ ...deviceInfoService.getDeviceInfo() },
                ...{ ...deviceInfoService.getAppInfo() },
                ...{ ...(props.headers || {}) },
            },
        });
        this.report();
    }

    static getInstance(props: IProps | any = {}) {
        if (!this.instance) {
            this.instance = new ProductDetailRestService(props);
        }
        return this.instance;
    }
    async init() {}

    _getImages(images: any) {
        let resultImg: any[] = [];
        images &&
            Array.isArray(images) &&
            images.forEach((item: any, index: number) => {
                if (item?.image)
                    resultImg.push({
                        original: item?.image,
                        thumbnail: item?.image,
                        thumbnailHeight: "100",
                        thumbnailClass: "image-thumb",
                    });
            });
        return resultImg;
    }

    async productDetailView(payload: any) {
        console.log(`payload in productDetailView`, payload)
        try {
            const res = await this.api.post(
                "/provenance/product_cred/no_auth/",
                {
                    gtin: payload
                }
            );
            if (res) {
                const _data = res?.data?.data?.productDetails;
                return {
                    PRODUCT_IMG: this._getImages(
                        _data?.ProductImages?.productImages
                    ),
                    ORGANIZATION_INFO: _data?.OrganizationInfo,
                    PRODUCT_DETAIL_INFO: _data?.ProductDetailInfo,
                    PRODUCT_TITLE_CARD: _data?.ProductTitleCard,
                };
            }
        } catch (err) {}
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
